import { DefaultMarkerIcon } from "@App/Components/atoms/map/markerIcons/DefaultMarkerIcon";
import { AkfLogo } from "@App/Components/atoms/whitelabel/logos/AkfLogo";
import type { Config } from "@App/configs/interfaces";

/**
 * Configuration for the AKF whitelabel.
 * Extends the default configuration with specific settings for AKF.
 */
export const config: Partial<Config> = {
  slug: "akf",
  navbar: {
    logos: {
      left: {
        component: <AkfLogo />,
      },
    },
  },
  reviews: {
    show: true,
  },
  map: {
    MarkerIcon: DefaultMarkerIcon,
    markerContent: "earliestSlot",
  },
};

export default config;
